/**
 * Serviceplan MAKEOS
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ZipFileResponse } from './zipFileResponse';


export interface DownloadData { 
    state: string;
    response?: Array<ZipFileResponse>;
}

